import { createDate, isSameOrAfter } from '@lingoda/dates';

export const isEndedClass = (end: string | Date, now: Date = createDate()) => {
    const endDate = typeof end === 'string' ? createDate(end) : end;

    return isSameOrAfter(now, endDate);
};
